export default __webpack_public_path__ + "static/media/exterior (4).5eb9d0be.jpg";